export default eventId =>
  // Show Forms V2 if is or after A+S LA
  //parseInt(eventId, 10) >= 1913;
  true;
